import { firebaseAuthService } from './firebaseAuthService';

export const authService = {
  // Admin login
  login: async ({ username, password }) => {
    try {
      return await firebaseAuthService.login({ username, password });
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  logout: async () => {
    try {
      await firebaseAuthService.logout();
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    }
  },

  getToken: () => firebaseAuthService.getToken(),
  
  getUser: () => firebaseAuthService.getUser(),
  
  isAuthenticated: () => firebaseAuthService.isAuthenticated(),

  // Écouter les changements d'état d'authentification
  onAuthStateChange: (callback) => firebaseAuthService.onAuthStateChange(callback)
};